import Section from './Section';
import { useTranslation } from 'react-i18next';
import useAuth from '../../../hooks/global/useAuth';
import CustomButton from '../../buttons/CustomButton';
import { ButtonTypes } from '../../../services/exports/Interfaces';
import useAppMethods from '../../../hooks/utility/useAppMethods';
import OrderInfo from '../OrderInfo';
import { SectionType } from './CheckoutInfoBag';
import useOrderFlow from '../../../hooks/order/useOrderFlow';
import { ENVIRONMENTS } from '../../../services/exports/Constants';

interface Props {
  toggleSection: (section: SectionType, open: boolean) => any;
}

export default function OrderInfoSection(props: Props) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Checkout:Sections:OrderInfoSection' });

  const { toggleSection } = props;

  const { isGuest } = useAuth();
  const { toggleLoginModal } = useAppMethods();
  const { update } = useOrderFlow();

  const fillDemoModeInfo = () =>
    update({
      customer_first_name: 'Max',
      customer_last_name: 'Mustermann',
      customer_email: 'max.musterman@demofoodamigos.io',
      customer_phone_number: '+491780000000',
    });

  return (
    <Section show hideDivider title="" className="p-md">
      {isGuest && (
        <div className="mb-lg">
          <p className="text-sm text-center">{t('labels.login')}</p>
          <CustomButton
            onClick={() => toggleLoginModal()}
            buttonType={ButtonTypes.secondary}
            title={t('buttons.login')}
            className="mt-md"
          />
          {import.meta.env.VITE_MODE !== ENVIRONMENTS.PROD && (
            <CustomButton
              onClick={fillDemoModeInfo}
              buttonType={ButtonTypes.secondary}
              title={t('buttons.demo_mode')}
              className="mt-md bg-gray"
              titleClass="!text-black"
            />
          )}
          <div className="mt-lg relative w-full flex">
            <p className="w-fit m-auto text-sm text-gray-700 uppercase bg-white px-sm z-10">
              {t('labels.continue_as_guest')}
            </p>
            <hr className="w-full absolute top-1/2" />
          </div>
        </div>
      )}
      <OrderInfo toggleSection={toggleSection} />
    </Section>
  );
}
